import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const GET_COUNTRIES_V2 = questionnaireGql(/* GraphQL */ `
  query getCountriesV2($panelSupplierCode: String!) {
    getCountriesV2(panelSupplierCode: $panelSupplierCode) {
      name
      countryCode
      languageName
      languageAllocationPercent
      locale {
        language
        country
      }
    }
  }
`)
